// *********************************************************
// Copyright (c) 2017 Agra Technologies Pvt. Ltd.. All rights reserved
// *********************************************************
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSettingsService } from './global-settings.service';
import { Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import moment from 'moment';
import _ from 'lodash';

// import _,{map} from 'underscore';

/** Matches backend models.Role.CLIENT_ADMIN_ROLE_ID; org admin = roleId ≤ this (Admin=1, Client Admin=2). */
export const CLIENT_ADMIN_ROLE_ID = 2;

@Injectable({ providedIn: "root" })
export class UserService {
  public redirectUrl: string = '';
  public loggedInUserRoles: string[] = [];
  public loggedInUserRolesID: number[] = [];
  public isOnline = true; // Hacked for Mahindra demo

  constructor(
    private globalSettingsService: GlobalSettingsService,
    private http: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar,
    public deviceDetector: DeviceDetectorService
  ) { }

  getCurrentGeolocation(): any {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          success => {
            let geolocation = { latitude: success.coords.latitude, longitude: success.coords.longitude };
            localStorage.setItem('geolocation', JSON.stringify(geolocation));
            resolve(success);

          },
          error => reject(error)
        );
      } else {
        reject('navigator.geolocation is undefined');
      }
    });
  }


  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('redirectUrl');
    this.loggedInUserRoles = [];
    this.redirectUrl = "";
    // to delete indexedDB
    window.indexedDB.deleteDatabase('moneytor.in');
    this.router.navigate(['/signin']);
  }

  logoutUser(): Observable<any> {
    const url = this.globalSettingsService.getApiUrl() + '/api/callService/logoutAgent';
    return this.http.get(url).pipe(catchError((e: any) => this.getCheckError(e, true)));
  }

  isLoggedIn() {
    return localStorage.getItem('isUserLoggedIn') === 'true';
  }

  getToken() {
    return localStorage.getItem('userJWT');
  }

  getUserAgentId() {
    return localStorage.getItem('userAgentId');
  }
  getCallingService() {
    return localStorage.getItem('callingService');
  }

  /**
   * Returns true if the currently logged in user has the specified role. (false if no user is currently logged in)
   */
  userHasRole(role: string): boolean {
    // If this.loggedInUserRoles is empty, the user may have refreshed the browser page. Try loading roles from localStorage
    if (this.loggedInUserRoles.length === 0) {
      if (localStorage.getItem('loggedInUserRoles')) {
        this.loggedInUserRoles = JSON.parse(
          (localStorage.getItem('loggedInUserRoles')!)
        );
      }
    }
    return this.loggedInUserRoles.includes(role);
  }

  getRedirectUrl() {
    return localStorage.getItem('redirectUrl');
  }
  getUserFunctions() {
    let userFunction = localStorage.getItem('userFunction');
    return userFunction ? JSON.parse(userFunction) : [];
  }

  // get Institute ID
  getInstituteId(): string {
    return (localStorage.getItem('instituteId')!);
  }

  /** Returns true when the current user has organization admin role (Admin or Client Admin, role id 1 or 2). */
  userHasOrganizationAdminRole(): boolean {
    let roleIds = this.loggedInUserRolesID;
    if (!roleIds || roleIds.length === 0) {
      const stored = localStorage.getItem('loggedInUserRolesID');
      if (stored) {
        try {
          roleIds = JSON.parse(stored);
        } catch {
          return false;
        }
      } else {
        return false;
      }
    }
    return Array.isArray(roleIds) && roleIds.some((id) => id === 1 || id === 2);
  }

  /**
   * Returns the first name of the logged in user (if any)
   */
  getFirstName(): string {
    return (localStorage.getItem('firstName')!);
  }

  /**
   * Returns the last name of the logged in user (if any)
   */
  getLastName(): string {
    return (localStorage.getItem('lastName')!);
  }

  /**
  * Returns the clientId for incoming call 
  */
  getClientId() {
    return localStorage.getItem('clientId');
  }

  removeClientId() {
    return localStorage.removeItem('clientId');
  }

  removeIncomingCall() {
    return localStorage.removeItem('incomingCall');
  }

  /**
   * Returns the ID of the logged in user (if any)
   */
  getLoggedInUserId(): string {
    return (localStorage.getItem('loggedInUserID')!);
  }

  getLoggedInUserEmail(): string {
    return (localStorage.getItem('loggedInEmail')!);
  }

  getLoggedInOrganizationId() {
    return localStorage.getItem('organizationId');
  }

  getFeatureList() {
    let featureList = localStorage.getItem('featureList');
    if (featureList) return JSON.parse(featureList);
    else return null;
  }

  setCallCommunicationDetailId(commDetailId: any) {
    sessionStorage.setItem('callCommunicationId', commDetailId);
  }
  getCallCommunicationDetailId() {
    return sessionStorage.getItem('callCommunicationId');
  }
  removeCallCommunicationDetailId() {
    return sessionStorage.removeItem('callCommunicationId');
  }

  /** Returns the roles of the logged in user */
  getRoles(): string[] {
    // If this.loggedInUserRoles is empty, the user may have refreshed the browser page. Try loading roles from localStorage
    if (this.loggedInUserRoles.length === 0) {
      if (localStorage.getItem('loggedInUserRoles')) {
        this.loggedInUserRoles = JSON.parse(
          (localStorage.getItem('loggedInUserRoles')!)
        );
      }
    }
    return this.loggedInUserRoles;
  }

  /** If AccessToken is Invalid , Returns the roles of the logged in user */
  getCheckError(error: any, flag?: any) {
    // flag used to display snackBar or not. 
    // if (!flag) {
    //   const msg = 'Cannot Reach Servers, Please try again';
    //   this.snackBar.open(msg, error.statusText ? error.statusText : 'okay', {
    //     duration: 5000,
    //     panelClass: ['error']
    //   });
    // }
    if (error.status === 401) {
      this.router.navigate(['/signin']);
      // this.logout();
      return throwError(false);
    }
    if (error.status === 503) {
      return throwError(error);
    }
    if (error.status === 500) {
      this.notify(error.error.resultLong, error.error.resultShort, 4000)
      return throwError(error);
    }
    if (error.status === 403) {
      return throwError(error);
    }

    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    // console.error(errMsg);
    return throwError(errMsg);

  }
  getDbName(): Observable<any> {
    const url = this.globalSettingsService.getApiUrl() + '/dbName';
    return this.http.get(url).pipe(catchError((e: any) => this.getCheckError(e, true)));
  }

  /** True if the user is Field (userFunction 2) or Tele/Telecaller (userFunction 3). Used to block access to organizations, allocations, profile. */
  isFieldOrTeleUser(): boolean {
    const fns = this.getUserFunctions();
    return Array.isArray(fns) && (fns.includes(2) || fns.includes(3));
  }

  checkFieldAgentOnMobile() {
    return this.getUserFunctions().includes(2) && this.deviceDetector.isMobile();
  }
  checkFieldAgentOnMobileIsOffline() {
    return this.getUserFunctions().includes(2) && this.deviceDetector.isMobile() && !navigator.onLine;
  }

  checkIsTelecallerOnMobile() {
    return this.getUserFunctions().includes(3) && this.deviceDetector.isMobile();
  }

  checkIsTeleCallerOffline() {
    return this.checkIsTelecallerOnMobile() && !navigator.onLine;
  }

  getUserLocation() {
    if (localStorage.getItem('geolocation')) {
      return JSON.parse(localStorage.getItem('geolocation')!);
    }
    return false;
  }

  clearCache() {
    if ('caches' in window) {
      window.caches.keys()
        .then((data) => {
          data.forEach(e => window.caches.delete(e));
        })
        // tslint:disable-next-line: no-console
        .catch((err) => console.error(err));
    }
  }

  // generic function to check is account expired or what
  checkForExpiryDate(expiryDate: any, actionDate: any) {
    const instituteId = +(localStorage.getItem('instituteId')!)
    // tslint:disable-next-line: no-parameter-reassignment
    expiryDate = moment(expiryDate).format('YYYY-MM-DD');
    /**
     * 76 - Mobikwik
     * Ignoring Expiry Date for Mobikwik
     */
    if (
      (instituteId !== 16) && (instituteId !== 76) && (expiryDate &&
        moment(actionDate).isAfter(expiryDate))
    ) {
      let errMsg = 'Action date cannot be greater than Expiry Date ' + moment(expiryDate).format('DD-MM-YYYY');
      this.notify(errMsg, 'error', 4000);
      return true;
    }
    return false;
  }

  notify(m1: string, m2: string, t: number = 3000) {
    this.snackBar.open(m1, m2, { duration: t, panelClass: m2.toLowerCase() })
  }

  validateForm(attr: any, data: any) {
    let flag: boolean = true;
    var regexp = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    if (!regexp.test(data.imageUrl)) {
      return this.notify('Please enter a valid Image URL', 'failure', 4000)
    }
    if (data.fieldJSON1.breakdownValues) {
      const newBreakdownValues = JSON.parse("[" + data.fieldJSON1.breakdownValues + "]");
      if (newBreakdownValues.length !== parseInt(data.minNoOfInstallments)) {
        this.notify("Breakdown values should be equal to number of Installments", 'failure', 4000);
        flag = false
        return flag
      }
      let a = 0;
      newBreakdownValues.forEach((arrayEl: any) => {
        a += arrayEl
      })
      if (a !== 100) {
        this.notify("BreakDown total should be 100", "failure", 4000);
        flag = false
        return flag
      }
    }

    attr.some((el: any) => {
      let desiredData = null;
      // data stored in nested object format, ie somewhere like fieldJSON1
      if (el.parentModel) {
        desiredData = data[el.parentModel][el.model]
      } else desiredData = data[el.model];

      if (el.required && !desiredData) {
        this.notify(`The ${el.name} should not be empty`, 'failure')
        flag = false;
      } else if (el.inputType === 'number' && desiredData && (desiredData > el['max'])) {
        this.notify(`The ${el.name} should not be greater than 
                    ${data.isInPercent == 0 ? `$${el.max}` : `${el.max}%`}`, 'failure', 4000)
        flag = false;
      }
      return !flag
    });
    return flag;
  }


  // generic get API call which takes in an endpoint
  getApiCall(endpoint: string, payload?: any): Observable<any> {
    let url = this.globalSettingsService.getApiUrl() + endpoint;
    if (payload) {
      url += '?q=' + btoa(JSON.stringify(payload));
      return this.http.get(url).pipe(catchError((e: any) => this.getCheckError(e, true)));
    } else return this.http.get(url).pipe(catchError((e: any) => this.getCheckError(e, true)));
  }

  // generic post API call which takes in an endpoint and postBody
  postApiCall(endpoint: string, postBody: any): Observable<any> {
    const isV3DashboardRoute = /(^|\/)(dashboard-v3|management-dashboard)(\/|$)/.test(
      location.pathname
    );
    endpoint = isV3DashboardRoute ? endpoint + '/v3' : endpoint;
    const url = this.globalSettingsService.getApiUrl() + endpoint;
    return this.http.post(url, postBody).pipe(catchError(e => this.getCheckError(e)));
  }


  // New function to fetch redis cache
  getRedisCache(postObj: any): Observable<any> {
    let base64data = btoa(JSON.stringify(postObj));
    return this.http
      .get(this.globalSettingsService.getApiUrl() + '/api/viewData/getFilters?q=' + base64data)
      .pipe(catchError((e: any) => this.getCheckError(e)));
  }

  getDataFromSessionStore(STORE_KEY: string) {
    let storeData = sessionStorage.getItem(STORE_KEY);
    if (_.isEmpty(storeData) || storeData === "undefined" || storeData === null) return {}
    else return JSON.parse(storeData);
  }

  /**
   * Storing communicationDetailId to send while creating createcustomerResponse
   * to avoid duplicate communication on same due.
   * @eventObj {DueId: DueId, commDetId: communicationDetailId}
   * @storeKey string
   */
  storeAndRemoveCommDetailId(eventObj: any, STORE_KEY: string) {
    // the store key 'callingRes' could be change, if there will be any conflict between progressive dialler and nativeApp calling
    // let STORE_KEY: string = storeKey ? storeKey : 'callingRes';
    let obj: any = JSON.parse(JSON.stringify(eventObj));
    let callRes = this.getDataFromSessionStore(STORE_KEY);
    const { DueId, remove } = obj;
    /** 
     * remove perticular due object if the customer response has created on that. */
    if (!_.isEmpty(callRes) && remove) delete callRes[DueId];
    else if (!remove) {
      /** 
       * create a final object to insert/update the session storage ('callingRes'). */
      let finalObj = { [DueId]: { ...obj } };
      /**
       *  merge old storage dataobject with new */
      callRes = { ...callRes, ...finalObj };
    }
    /** 
     * update the session storage with new and updated dataobject. */
    sessionStorage.setItem(STORE_KEY, JSON.stringify(callRes));
  }
}
